import { ErrorPage } from '@/components/errors';
import { useGetDevices, useGetPersonalInfo } from '@/hooks/api';
import { ModuleName, Screen, templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useDeleteDevice } from './-hooks/delete-device.hooks';
import { type TvProps } from './-model/props';
import { TvLight, TvWooDark, TvWoo } from './-skins';

export const Route = createFileRoute('/(tv)/tv/$id')({
  component: RouteComponent,
  errorComponent: ErrorPage,
  staticData: {
    module: ModuleName.Tv,
    screen: Screen.LandingPage,
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data: devices, isLoadingData } = useGetDevices(id);
  const { data: personalInfo, isLoadingData: isLoadingPersonalInfo } = useGetPersonalInfo();
  const { mutate, isPending } = useDeleteDevice();
  const props: TvProps = {
    devices: devices ?? [],
    isLoadingDevices: isLoadingData,
    sa: id,
    deleteDevice: (device) => {
      if (device.IsLocked || isPending) return;
      mutate({ id: device.Id, sa: id });
    },
    deleteDeviceLoading: isPending,
    canEditPins: personalInfo?.Type === 'Primary',
    canEditPinsLoading: isLoadingPersonalInfo,
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: TvProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <TvWooDark {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <TvWoo {...props} />,
      },
    ],
    defaultValue: <TvLight {...props} />,
  };
}
